'use client'

import { useEffect } from 'react'

export default function HubSpotScript() {
  useEffect(() => {
    // Only load HubSpot after hydration is complete
    const timer = setTimeout(() => {
      const script = document.createElement('script')
      script.src = '//js-ap1.hs-scripts.com/441838444.js'
      script.async = true
      script.defer = true
      script.id = 'hs-script-loader'
      document.body.appendChild(script)
    }, 100) // Small delay to ensure hydration is complete

    return () => clearTimeout(timer)
  }, [])

  return null
}
